import { render } from "./AudiencePanel.vue?vue&type=template&id=ab8a6d46"
import script from "./AudiencePanel.vue?vue&type=script&lang=js"
export * from "./AudiencePanel.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3192284683/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__